import {
  ApolloClient,
  ApolloError,
  ApolloProvider,
  from,
  HttpLink,
  InMemoryCache,
} from '@apollo/client';
import { onError } from '@apollo/client/link/error';
import { PropsWithChildren, useMemo } from 'react';
import { toast } from 'react-toastify';
import { getApolloErrorsForToast } from '../utils/errors.tsx';

const PublicApolloProvider = ({ children }: PropsWithChildren) => {
  const client = useMemo(() => {
    const httpLink = new HttpLink({
      uri: import.meta.env.VITE_API_URL + '/graphql',
    });

    const errorLink = onError(({ graphQLErrors, networkError, operation }) => {
      if (graphQLErrors) {
        toast.error(getApolloErrorsForToast({ graphQLErrors } as ApolloError));
      }
      if (networkError) {
        if (operation.getContext().fetchOptions?.signal?.aborted) return;
        toast.error('Network error');
        console.log(`[Network error]: ${networkError}`);
      }
    });

    return new ApolloClient({
      link: from([errorLink, httpLink]),
      cache: new InMemoryCache(),
      defaultOptions: {
        query: {
          errorPolicy: 'all',
        },
      },
      devtools: {
        enabled: import.meta.env.MODE === 'development',
      },
    });
  }, []);

  return <ApolloProvider client={client}>{children}</ApolloProvider>;
};

export default PublicApolloProvider;
